require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/fn/get-iterator.js
// module id = ../../../node_modules/core-js/library/fn/get-iterator.js
// module chunks = 0